const WHATS_NEXT_ITEMS = [
  {
    iconSrc: '/static/images/svg/emailCircle.svg',
    altText: 'Email and Contact',
    mobileText: 'Don’t worry, no late fees and we’ll keep you posted',
    mobileOrder: 2,
    desktopOrder: 1,
    desktopText: [
      'Don’t worry, no late fees and we’ll keep you posted'
    ]
  },
  {
    iconSrc: '/static/images/svg/reviewCircle.svg',
    altText: 'Review Tickets',
    mobileText: 'Our experts will review your tickets',
    mobileOrder: 1,
    desktopOrder: 2,
    desktopText: [
      'Our experts will review your tickets'
    ]
  },
  {
    iconSrc: '/static/images/svg/clockCircle.svg',
    altText: 'It takes time',
    mobileText: 'Be patient, it will take some time',
    mobileOrder: 2,
    desktopOrder: 3,
    desktopText: [
      'Be patient, it will take some time'
    ]
  }
]

export default WHATS_NEXT_ITEMS
